export default "__VITE_ASSET__e_rAE06R__"